import { ReactNode } from 'react';
import styled from 'styled-components';
import { colors, spacing } from '@ardoq/design-tokens';
import { FORM_WRAPPER_SELECTOR } from '@ardoq/forms';
import { TABS_GROUP_HEADER_SELECTOR } from '@ardoq/tabs';

export const MODAL_BODY_ID = 'modal-body';

const ModalBodyStyle = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: ${spacing.s16};
  background: ${colors.surfaceDefault};
  overflow-y: auto;

  ${TABS_GROUP_HEADER_SELECTOR} {
    padding: 0 ${spacing.s16};
    border-bottom: 1px solid ${colors.borderSubtle};
  }

  & > ${FORM_WRAPPER_SELECTOR} {
    max-width: 700px;
  }
`;

export type ModalBodyProps = {
  children?: ReactNode;
  className?: string;
};

const ModalBody = ({ children, className }: ModalBodyProps) => (
  <ModalBodyStyle id={MODAL_BODY_ID} className={className}>
    {children}
  </ModalBodyStyle>
);

export { ModalBody };
